import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Row, Col, Container } from 'react-bootstrap'
import Maniquis1 from '../Educativo/Maniquis1.jpg'
import Maniqui2 from '../Educativo/Maniqui2.jpg'

export class MedEducational extends Component {
    render() {
        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Medical & Educational</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Estándar de 2 columnas para imágenes con información detallada */}
                    <Row className="justify-content-center g-4">
                        <Col xs={12} lg={6}>
                            <Card className="shadow-sm border-0 text-center h-100">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={Maniquis1} 
                                        style={{ width: '100%', height: 'auto', objectFit: 'contain' }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.5rem' }}>Educational Training Mannequins</Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>

                        <Col xs={12} lg={6}>
                            <Card className="shadow-sm border-0 text-center h-100">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={Maniqui2} 
                                        style={{ width: '100%', height: 'auto', objectFit: 'contain' }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.5rem' }}>Childbirth Simulation Mannequin</Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}